module.exports = __webpack_public_path__ + "static/media/55_000028.6128b355.jpg";